import { Teilimpfungsart } from '@/types/Teilimpfungsart';

export default class Teilimpfungen {
    public teilimpfung_id: number | null = null;
    public impfstoff_id: number | null = null;
    public teilimpfungsnr: number | null = null;
    public impfschema_code: string | null = null;
    public impfdosis_code: string | null = null;
    public information: string | null = null;
    public abstand_jahre: number | null = null;
    public abstand_monate: number | null = null;
    public abstand_wochen: number | null = null;
    public abstand_tage: number | null = null;
    public abstand2_alter: number | null = null;
    public abstand2_jahre: number | null = null;
    public abstand2_monate: number | null = null;
    public abstand2_wochen: number | null = null;
    public abstand2_tage: number | null = null;
    public impfdb_impfartnr: number | null = null;
    public impfdosis_teilimpfung: string | null = null;
    public impferinnerung: string | null = null;
    public impferinnerungstext: string | null = null;

    public get isEinfachimpfung(): boolean {
        return this.teilimpfungsnr === Teilimpfungsart.Einfachimpfung;
    }

    public get isTeilimpfung(): boolean {
        return this.impfdosis_teilimpfung === 'j';
    }

    public get isAuffrischung(): boolean {
        return !this.isEinfachimpfung && !this.isTeilimpfung;
    }

    public constructor(teilimpfungsnr: number | null = null, values: Partial<Teilimpfungen> | undefined = undefined) {
        this.teilimpfungsnr = teilimpfungsnr;

        if (values) {
            Object.assign(this, values);
        }
    }
}
